import catchCancel from 'helpers/catchCancel';
import { toastManager } from 'components/ToastContainer/toastManager';
import { convertDensityFromKgPerLToLbsPerGal } from './convertDensity';

export const handleMasterProduct = setSchema => {
  setSchema('MASTER');
};

export const handleServiceProduct = (product, setCustomProduct, setSchema) => {
  setCustomProduct(product);
  setSchema('SERVICE');
};

export const handleFertilizerProduct = (
  product,
  setCustomProduct,
  setSchema,
  fetchCustomProduct,
  visible
) => {
  setCustomProduct(product);
  setSchema('FERTILIZER');

  // Rows coming from the Add Product drawer only carry `id`; api.fetch falls
  // back to the collection endpoint when the id is undefined, which would seed
  // the form with a product list instead of a product.
  const productId = product.productId ?? product.id;

  if (visible && !product.isNew && productId) {
    fetchCustomProduct(productId)
      .then(res => {
        setCustomProduct({
          ...res.data,
          // The detail response can omit Make-Up; fall back to the value the
          // user already had so it is retained on edit.
          makeUp: res?.data?.makeUp ?? product.makeUp,
          averagePricePerUnit: product.averagePricePerUnit,
          averagePricePerUnitUnit: product.averagePricePerUnitUnit,
          custom: true,
          densityInLbsPerGallon: convertDensityFromKgPerLToLbsPerGal(
            product?.density
          )
        });
      })
      .catch(catchCancel)
      .catch(() => {
        // The drawer keeps the row data set above, so the form still renders
        // rather than leaving the request to reject unhandled.
        toastManager.error('Unable to load product details', {
          content: 'Showing limited product info.'
        });
      });
  }
};
